module.exports = __webpack_public_path__ + "img/profitGreen.3618c0a5.png";